import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from '../services/apiClient';

const ADMIN_BASE = '/api/admin/landing-videos';
const PUBLIC_BASE = '/api/public/landing-videos';

export const listLandingVideosAdmin = (token) => apiGet(ADMIN_BASE, token);
export const createLandingVideo = (payload, token) => apiPost(ADMIN_BASE, payload, token);
export const updateLandingVideo = (id, payload, token) => apiPut(`${ADMIN_BASE}/${id}`, payload, token);
export const deleteLandingVideo = (id, token) => apiDelete(`${ADMIN_BASE}/${id}`, token);
export const toggleLandingVideo = (id, isActive, token) =>
  apiPatch(`${ADMIN_BASE}/${id}/toggle`, { is_active: isActive }, token);
export const reorderLandingVideos = (items, token) =>
  apiPatch(`${ADMIN_BASE}/reorder`, { items }, token);
export const listLandingVideosPublic = () => apiGet(PUBLIC_BASE);
